import {
  white,
  brownishGrey,
  peacockBlue,
  lightGrey,
  dark,
  alertRed,
} from '@g4/boneyard/lib/theme/colors';
import common from './colors.common';

// /boneyard/Checkbox
export const checkbox = {
  active: peacockBlue,
  background: white,
  backgroundDisabled: lightGrey,
  backgroundActive: peacockBlue,
  checkmark: peacockBlue,
  checkmarkActive: white,
  checkmarkDisabled: brownishGrey,
  checkmarkError: alertRed,
  focused: common.form.focused,
  outline: peacockBlue,
  outlineDisabled: brownishGrey,
  stroke: lightGrey,
};

// /boneyard/Select

export const focusStyle = `
  outline: none;
  box-shadow: 0 0 0 2px ${common.form.focused};
`;

export const select = {
  selected: dark,
  optionText: peacockBlue,
  disabledText: brownishGrey,
  disabledBackground: white,
  placeholderText: brownishGrey,
  groupDivider: lightGrey,
  error: common.form.required,
  focused: common.form.focused,
};

// /boneyard/Input
export const input = {
  disabledText: brownishGrey,
  disabledBackground: white,
  error: common.form.required,
  focused: common.form.focused,
};

// /boneyard/RadioGroup/Radio
export const radio = {
  focused: common.form.focused,
  background: white,
  checked: peacockBlue,
  stroke: lightGrey,
};
